export const CONDITION_PROMPT_ERROR_CATEGORY = 'ConditionPromptErrorCode';

export enum ConditionPromptErrorCode {
	Unanswerable = 1,
	Vague = 2,
}

const isConditionPromptErrorCode = (value: unknown): value is ConditionPromptErrorCode =>
	value === ConditionPromptErrorCode.Unanswerable || value === ConditionPromptErrorCode.Vague;

export const getConditionPromptErrorCode = (error: unknown): ConditionPromptErrorCode | undefined => {
	const technicalError = (error as { error?: { category?: string; errorCode?: number } } | null)?.error;
	if (technicalError?.category !== CONDITION_PROMPT_ERROR_CATEGORY) {
		return undefined;
	}
	return isConditionPromptErrorCode(technicalError.errorCode) ? technicalError.errorCode : undefined;
};
